import React from 'react'
import './footer.css';
function Footer() {
  return (
    <footer className="footer">
        Copyright &#169; 2024 Abhijit Swain. All right received.
    </footer>
  )
}

export default Footer